import { tokens } from '@opendoor/tokens-studio/dist/bricks-next/tokens/Components';

import { isKeyOfObject } from '../../../helpers/utils';
import { Box } from '../../Box';
import { useCheckInputLabel } from '../../shared/InputLabelContext';
import { Text } from '../../Text';
import type { InputProps, InputStateProp } from './InputProps';

const { textInput: textInputTokens } = tokens;

/**
 * Label for input components
 */
export const InputLabel = ({
  size,
  title,
  supportText,
  id,
  required,
  state,
}: Pick<InputProps, 'size' | 'title' | 'supportText' | 'id' | 'required'> & InputStateProp) => {
  useCheckInputLabel(title);

  if (!title) {
    return null;
  }

  return (
    <Box gap={textInputTokens.padding.gap.titleAndSupport.default}>
      <Text
        tag="label"
        htmlFor={id}
        typography={textInputTokens.typography.fieldTitle[size]}
        color={
          isKeyOfObject(state, textInputTokens.color.content.fieldTitle.state)
            ? textInputTokens.color.content.fieldTitle.state[state]
            : textInputTokens.color.content.fieldTitle.default
        }
      >
        {title}
        {required ? ' *' : ''}
      </Text>

      {!!supportText && (
        <Text
          tag="span"
          typography={textInputTokens.typography.supportText.default}
          color={
            isKeyOfObject(state, textInputTokens.color.content.supportText.state)
              ? textInputTokens.color.content.supportText.state[state]
              : textInputTokens.color.content.supportText.default
          }
        >
          {supportText}
        </Text>
      )}
    </Box>
  );
};
